<script>
  import LoadingScreen from "../../components/LoadingScreen.svelte";
  import TacticalViewCanvas from "./TacticalViewCanvas.svelte";

  export let teams = {
    home: {
      name: "1. FC Köln",
      logo: "/img/logos/fc-koln-logo.svg",
      color: "#ff0000",
      contrastColor: "black",
    },
    guest: {
      name: "Bayer Leverkusen",
      logo: "/img/logos/bayer-logo.svg",
      color: "#0000ff",
      contrastColor: "white",
    },
  };

  let playerPos = [
    {
      name: "Manuel Neuer",
      team: "1. FC Köln",
      number: 1,
      position: { x: 110, y: 600 },
    },
    {
      name: "Lionel Messi",
      team: "Bayer Leverkusen",
      number: 13,
      position: { x: 30, y: 30 },
    },
    {
      name: "Alina",
      team: "Bayer Leverkusen",
      number: 1,
      position: { x: 120, y: 100 },
    },
    {
      name: "Enrico",
      team: "1. FC Köln",
      number: 13,
      position: { x: 300, y: 500 },
    },
    {
      name: "ball",
      team: "none",
      position: { x: 50, y: 60 },
    },
  ];

  let socket = io("https://football.enick.ninja");
  let loading = true;

  socket.on("connect", function () {
    loading = false;
  });

  socket.on("goal", () => {
    guestScore = 1;
    setTimeout(() => {
      guestScore = 0;
    }, 2000);
  });
  let guestScore = 0;
  let homeScore = 0;
</script>

{#if loading}
  <LoadingScreen />
{:else}
  <div id="tactical-view-holder">
    <TacticalViewCanvas {playerPos} {teams} />
  </div>

  <div id="tactical-results-view">
    <div class="home team" style="border-color: {teams.home.color}">
      <object type="image/svg+xml" data={teams.home.logo} />
    </div>
    <div class="info">
      <p class="score">{guestScore}:{homeScore}</p>
      <p class="time">20. Minute</p>
    </div>
    <div class="guest team" style="border-color: {teams.guest.color}">
      <object type="image/svg+xml" data={teams.guest.logo} />
    </div>
  </div>
{/if}

<style type="text/scss">
  div {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 30px;
  }
  #tactical-results-view {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;

    div {
      display: inline-block;
      background: none;
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        margin: 0;
      }

      .score {
        font-size: 3rem;
      }
    }

    .team {
      border-radius: 100%;
      overflow: hidden;
      height: 100px;
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;

      object {
        max-width: 100%;
      }

      background: white;
      border: 5px solid red;
    }
  }
</style>
